// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3bZMl","approved":"Status_approved__1K7NJ","rejected":"Status_rejected__2llq6","expired":"Status_expired__2BbjO","label":"Status_label__1jfqa"};